import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { Observable, shareReplay } from 'rxjs';
import { Information, InformationType, SaveInformationRequest } from '@app/information/models/information';

@Injectable({
  providedIn: 'root',
})
export class InformationService extends ApiService {
  private types$?: Observable<InformationType[]>;
  constructor(public http: HttpClient) {
    super(http);
  }

  public getAll(query?: Record<string, string>): Observable<Information[]> {
    return this.http.get<Information[]>(this.endpoint(`api`, `information`), { params: query });
  }

  public getById(id: string): Observable<Information> {
    return this.http.get<Information>(this.endpoint(`api`, `information`, id));
  }

  public getTypes(): Observable<InformationType[]> {
    this.types$ ??= this.http.get<InformationType[]>(this.endpoint(`api`, `information`, `types`)).pipe(shareReplay({ bufferSize: 1, refCount: true }));
    return this.types$;
  }

  public delete(id: string): Observable<void> {
    return this.http.delete<void>(this.endpoint(`api`, `information`, id));
  }

  public postInformation = (information: SaveInformationRequest): Observable<Information> =>
    this.http.post<Information>(this.endpoint(`api`, `information`), information);

  public putInformation = (information: SaveInformationRequest): Observable<Information> =>
    this.http.put<Information>(this.endpoint(`api`, `information`), information);
}
